import ScrapingRed from '../../../assets/scraping-red.svg?react'
import Close  from '../../../assets/close.svg?react'
import styles from '../Scraping/Scraping.module.css'
import { getActiveGeocontext } from '../../../utils'
import {
  useLastCommonsStatusGeocontext,
  useStartCommons,
  useStopCommons,
} from '../../../hooks/geocontext'
import { useEffect } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

export default function ScrapingCommons({
  scrapingCommonsOpen,
  setScrapingCommonsOpen,
}: {
  scrapingCommonsOpen: boolean
  setScrapingCommonsOpen: (value: boolean) => void
}) {
  const { t } = useTranslation()
  const activeGeocontext = getActiveGeocontext()
  const lastCommons = useLastCommonsStatusGeocontext(activeGeocontext?.id || 0)
  const {
    mutateAsync: startCommons,
    isLoading: isStartScrapingLoading,
    error: startScrapingError,
  } = useStartCommons(activeGeocontext?.id || 0)

  const {
    mutateAsync: stopCommons,
    isLoading: isStopScrapingLoading,
    error: stopScrapingError,
  } = useStopCommons(activeGeocontext?.id || 0)

  //polling
  useEffect(() => {
    const interval = setInterval(() => {
      lastCommons.refetch()
    }, 8000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div
      className={styles.ScrapingOverlay}
      role="dialog"
      aria-modal="true"
      onClick={close}
    >
      <div className={styles.ScrapingModal}>
        <div className="w-100 h-100 d-flex justify-content-center position-relative">
          <div
            className={styles.HomeContent}
            style={{
              width: 532,
              transition: 'width 0.3s ease-in-out',
            }}
          >
            <div
              className={styles.Close}
              onClick={() => setScrapingCommonsOpen(false)}
            >
              <Close />
            </div>
            <div className={styles.Title}>
              <ScrapingRed className="me-2" /> Scraping Commons
            </div>

            {/* Last Commons run */}
            {!!lastCommons.data?.last_commons_update && (
              <>
                <div className="d-flex flex-column justify-content-between mt-4">
                  <div className={styles.Desc}>
                    {t('LAST_COMMONS_PERFORMED_ON')}{' '}
                    {dayjs(lastCommons.data?.last_commons_update).format(
                      'DD/MM/YYYY HH:mm'
                    )}
                  </div>
                  <div className={styles.Desc}>
                    {t('LAST_COMMONS_TOTAL_MONUMENTS')}{' '}
                    {lastCommons.data?.last_commons_update_total_monuments}
                  </div>
                </div>
              </>
            )}

            {/* Never run Commons */}
            {!!lastCommons.data && !!!lastCommons.data?.last_commons_update && (
              <div className="d-flex align-items-center justify-content-between mt-4">
                <div className={styles.Desc}>{t('NO_COMMONS_DONE')} </div>
              </div>
            )}

            {/* Running commons: show stop button */}
            {!!lastCommons.data?.last_commons_started && (
              <>
                <div className="d-flex flex-column justify-content-between mt-4">
                  <div className={styles.Desc}>
                    {t('LAST_SCRAPING_RUNNING_STARTED')}{' '}
                    {dayjs(lastCommons.data?.last_commons_started).format(
                      'DD/MM/YYYY HH:mm'
                    )}
                  </div>
                  <div className={styles.Desc}>
                    {t('RUNNING_COMMONS_MONUMENTS_NUMBER')}{' '}
                    {lastCommons.data?.last_commons_started_done_monuments} /{' '}
                    {lastCommons.data?.last_commons_started_total_monuments}
                  </div>
                </div>

                <div className="w-100 mt-2">
                  <button
                    className="btn btn-danger w-100 btn-sm"
                    disabled={isStopScrapingLoading}
                    onClick={() =>
                      stopCommons().then(() => lastCommons.refetch())
                    }
                  >
                    {t('STOP_COMMONS')}
                  </button>
                </div>
              </>
            )}

            {/* not started osm and not queued */}
            {!!!lastCommons.data?.last_commons_started &&
              !!!lastCommons.data?.last_commons_queued && (
                <>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className={styles.Desc}>
                      {t('NO_COMMONS_RUNNING')}{' '}
                    </div>
                  </div>
                  <div className="w-100 mt-2">
                    <button
                      className="btn btn-danger btn-sm w-100"
                      disabled={isStartScrapingLoading}
                      onClick={() =>
                        startCommons().then(() => lastCommons.refetch())
                      }
                    >
                      {t('START_COMMONS')}
                    </button>
                    {!!lastCommons.data?.last_commons_update_error && (
                      <div className="text-danger mt-2">
                        {lastCommons.data?.last_commons_update_error}
                      </div>
                    )}
                  </div>
                </>
              )}

            {/* task is queued */}
            {!!!lastCommons.data?.last_commons_started &&
              lastCommons.data?.last_commons_queued && (
                <>
                  <div className="d-flex align-items-center justify-content-between mt-4">
                    <div className={styles.Desc}>{t('OSM_QUEUED')} </div>
                  </div>

                  <div className="w-100 mt-2">
                    <button
                      className="btn btn-danger w-100 btn-sm"
                      disabled={isStopScrapingLoading}
                      onClick={() =>
                        stopCommons().then(() => lastCommons.refetch())
                      }
                    >
                      {t('STOP_COMMONS')}
                    </button>
                  </div>
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}
